




import Vue from "vue";

export default Vue.extend({
  props: {
    uiApp: {
      type: Object as () => any,
      required: true
    },
    signInOptions: {
      type: Array as () => any,
      required: true
    }
  },
  mounted() {
    this.uiApp.start("#firebaseui-auth-container", {
      signInSuccessUrl: this.$router.resolve({ name: "root" }).href,
      signInOptions: this.signInOptions
    });
  },
  destroyed() {
    this.uiApp.reset();
  }
});
